import create from 'zustand';
import { Usuario } from '../pages/models';

export const LoginStore = create((set: any) => ({
  Log: false,
  CadastroFinalizado: false,
  userAtivo: new Usuario(),
  setLog: (el: boolean) => set(() => ({ Log: el })),
  setUserAtivo: (el: any) => set(() => ({ userAtivo: el })),
  setCadastroFinalizado: (el: any) => set(() => ({ CadastroFinalizado: el })),
  // inc: () => set((state) => ({ count: state.count + 1 })),
}));

export const LinksStore = create((set: any) => ({
  LinkSite: '',
  LinkPoliticas: '',
  Imagem: '',
  setLinkSite: (el: any) => set(() => ({ LinkSite: el })),
  setLinkPoliticas: (el: any) => set(() => ({ LinkPoliticas: el })),
  setImagem: (el: any) => set(() => ({ Imagem: el })),
  // inc: () => set((state) => ({ count: state.count + 1 })),
}));
